import type { Signal } from "@suse-o11y/signal";
import React from "react";
import { useSelector } from "react-redux";

import { selectAllSearchParams } from "../../../app/state/route/RouteSelectors";

import { TimeRangeHistoryContext } from "./_time-range-history-context";
import { type TimeRangeHistory, useInitTimeRangeHistory } from "./time-range-history-utils";

export interface TimeRangeHistoryProviderProps {
	history?: Signal<TimeRangeHistory>;
}

export const TimeRangeHistoryProvider: React.FC<React.PropsWithChildren<TimeRangeHistoryProviderProps>> = ({
	history,
	children,
}) => {
	const { timeRange: timeRangeFromSearch } = useSelector(selectAllSearchParams);
	const timeRangeHistory = useInitTimeRangeHistory(timeRangeFromSearch);

	return (
		<TimeRangeHistoryContext.Provider value={history ?? timeRangeHistory}>{children}</TimeRangeHistoryContext.Provider>
	);
};
